module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('shop-select', {
    attrs: {
      "wxshops": ""
    },
    on: {
      "update": _vm.shopHandle
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "daterange",
      "placeholder": "选择日期范围",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "size": "mini"
    },
    on: {
      "change": _vm.dateChange
    },
    model: {
      value: (_vm.create_time),
      callback: function($$v) {
        _vm.create_time = $$v
      },
      expression: "create_time"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "手机号/交易单号",
      "size": "mini"
    },
    model: {
      value: (_vm.mobile),
      callback: function($$v) {
        _vm.mobile = $$v
      },
      expression: "mobile"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.numberSearch
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 4,
      "lg": 4
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出")]), _vm._v(" "), _c('el-popover', {
    attrs: {
      "placement": "top-start",
      "width": "200",
      "trigger": "hover",
      "content": "导出任务会以队列执行，点击导出后，请至‘设置-导出列表’页面中查看及下载数据"
    }
  }, [_c('i', {
    staticClass: "el-icon-question",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  })])], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "交易单下载",
      "visible": _vm.downloadView,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.downloadView = $event
      }
    }
  }, [(_vm.downloadUrl) ? [_c('a', {
    attrs: {
      "href": _vm.downloadUrl,
      "download": ""
    }
  }, [_vm._v(_vm._s(_vm.downloadName))])] : _vm._e()], 2), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "全部",
      "name": "all"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "支付完成",
      "name": "success"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "未支付",
      "name": "notpay"
    }
  }), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list,
      "height": _vm.wheight - 140
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-form', {
          staticClass: "demo-table-expand",
          attrs: {
            "label-position": "left",
            "inline": ""
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "订单号："
          }
        }, [_c('router-link', {
          attrs: {
            "to": {
              path: _vm.$route.path.indexOf('servicetrade') === -1 ? _vm.matchInternalRoute('tradenormalorders_detail') : _vm.matchInternalRoute('tradeservice_detail'),
              query: {
                orderId: scope.row.orderId,
                resource: '/mall/trade/payment'
              }
            }
          }
        }, [_vm._v(_vm._s(scope.row.orderId))])], 1), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "支付方式："
          }
        }, [(scope.row.payType == 'wxpay') ? _c('span', [_vm._v("微信支付")]) : _vm._e(), _vm._v(" "), (scope.row.payType == 'wxpayapp') ? _c('span', [_vm._v("微信APP支付")]) : _vm._e(), _vm._v(" "), (scope.row.payType == 'alipayapp') ? _c('span', [_vm._v("支付宝APP支付")]) : _vm._e(), _vm._v(" "), (scope.row.payType == 'alipay') ? _c('span', [_vm._v("支付宝支付")]) : _vm._e(), _vm._v(" "), (scope.row.payType == 'deposit') ? _c('span', [_vm._v("余额支付")]) : _vm._e(), _vm._v(" "), (scope.row.payType == 'pos') ? _c('span', [_vm._v("POS银行卡支付")]) : _vm._e(), _vm._v(" "), (scope.row.payType == 'fuioupay_miniprogram') ? _c('span', [_vm._v("富友微信小程序支付")]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "总金额："
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.curFeeSymbol) + _vm._s(scope.row.totalFee / 100))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "优惠金额："
          }
        }, [(scope.row.discountInfo) ? _c('el-popover', {
          attrs: {
            "trigger": "hover",
            "placement": "top"
          }
        }, [_vm._l((scope.row.discountInfo), function(item) {
          return _c('div', [(item.discount_fee) ? _c('div', [(item.coupon_code) ? _c('p', [_vm._v("优惠券码：" + _vm._s(item.coupon_code))]) : _vm._e(), _vm._v(" "), (item.member_card_code) ? _c('p', [_vm._v("会员卡号：" + _vm._s(item.member_card_code))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("优惠原因：" + _vm._s(item.info))]), _vm._v(" "), _c('p', [_vm._v("优惠方案：" + _vm._s(item.rule))]), _vm._v(" "), _c('p', [_vm._v("优惠金额：" + _vm._s(scope.row.curFeeSymbol) + _vm._s(item.discount_fee / 100) + " 元")]), _vm._v(" "), _c('hr')]) : _vm._e()])
        }), _vm._v(" "), _c('div', {
          staticClass: "name-wrapper",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_vm._v("\n                  " + _vm._s(scope.row.discountFee / 100) + "元\n                ")])], 2) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label-width": "120px",
            "label": "支付流水号："
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.transactionId))])])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "timeStart",
      "label": "交易时间",
      "min-width": "84"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("datetime")(scope.row.timeStart, 'yyyy-MM-dd hh:mm:ss')))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tradeId",
      "label": "交易单号",
      "min-width": "84"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mobile",
      "label": "用户手机号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "body",
      "label": "支付详情"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "payFee",
      "label": "支付金额(RMB)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v("￥" + _vm._s(scope.row.payFee / 100))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单金额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.curPayFee) ? _c('span', [_vm._v("￥" + _vm._s(scope.row.curPayFee / 100))]) : _c('span', [_vm._v(_vm._s(scope.row.curFeeSymbol) + _vm._s(scope.row.totalFee / 100))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "汇率"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.curFeeRate))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tradeState",
      "label": "支付状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.tradeState == 'SUCCESS') ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v("支付成功")]) : (scope.row.tradeState == 'NOTPAY') ? _c('el-tag', {
          attrs: {
            "size": "mini"
          }
        }, [_vm._v("未支付")]) : (scope.row.tradeState == 'CLOSED') ? _c('el-tag', {
          attrs: {
            "type": "primary",
            "size": "mini"
          }
        }, [_vm._v("已关闭")]) : (scope.row.tradeState == 'REVOKED') ? _c('el-tag', {
          attrs: {
            "type": "primary",
            "size": "mini"
          }
        }, [_vm._v("已撤销")]) : (scope.row.tradeState == 'PAYERROR') ? _c('el-tag', {
          attrs: {
            "type": "primary",
            "size": "mini"
          }
        }, [_vm._v("支付失败")]) : (scope.row.tradeState == 'REFUND_PROCESS') ? _c('el-tag', {
          attrs: {
            "type": "warning",
            "size": "mini"
          }
        }, [_vm._v("退款处理中")]) : (scope.row.tradeState == 'REFUND_SUCCESS') ? _c('el-tag', {
          attrs: {
            "type": "info",
            "size": "mini"
          }
        }, [_vm._v("退款成功")]) : (scope.row.tradeState == 'REFUND_FAIL') ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v("退款失败")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-center content-padded"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "total, sizes, prev, pager, next",
      "current-page": _vm.params.page,
      "page-sizes": [10, 20, 50],
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5a64a261", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a64a261"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/trade/list.vue
// module id = 2744
// module chunks = 0